import { ComponentFactory } from "@encoway/react-configurator"

import { ARDialog } from "./components/ARDialog/ARDialog"
import { AssemblyApp } from "./components/AssemblyApp/AssemblyApp"
import { BusyOverlay } from "./components/BusyOverlay/BusyOverlay"
import { CUIApp } from "./components/CUIApp/CUIApp"
import { Header } from "./components/Header/Header"
import { HeaderMenu } from "./components/HeaderMenu/HeaderMenu"
import { InitialLoadingSpinner } from "./components/InitialLoadingSpinner/InitialLoadingSpinner"
import { MessageBox } from "./components/MessageBox/MessageBox"
import { ProductPrice } from "./components/ProductPrice/ProductPrice"
import { ProductText } from "./components/ProductText/ProductText"
import { ProductTitle } from "./components/ProductTitle/ProductTitle"
import { Visualization } from "./components/Visualization/Visualization"
import { ComponentName } from "./constants"
import de from "./translations_de.json"
import en from "./translations_en.json"

export * from "./index.types"
export * from "./components/CUIApp/CUIApp"
export * from "./components/CUIApp/CUIApp.styles"
export * from "./components/AssemblyApp/AssemblyApp"
export * from "./components/AssemblyApp/AssemblyApp.styles"
export * from "./components/BorderLayout/BorderLayout"

export * from "./components/Visualization/Visualization"
export * from "./components/Visualization/Visualization.styles"
export * from "./components/VisualizationWrapper/VisualizationWrapper"
export * from "./components/VisualizationWrapper/VisualizationWrapper.styles"
export * from "./services/visualization/visualizationService"

export * from "./components/ARDialog/ARDialog"
export * from "./components/ARDialog/ARDialog.styles"

export * from "./components/Header/Header"
export * from "./components/Header/Header.styles"
export * from "./components/HeaderMenu/HeaderMenu"
export * from "./components/HeaderMenu/HeaderMenu.styles"
export * from "./components/ProductTitle/ProductTitle"
export * from "./components/ProductTitle/ProductTitle.styles"
export * from "./components/ProductText/ProductText"
export * from "./components/ProductText/ProductText.styles"
export * from "./components/ProductPrice/ProductPrice"
export * from "./components/ProductPrice/ProductPrice.styles"

export * from "./components/InitialLoadingSpinner/InitialLoadingSpinner"
export * from "./components/InitialLoadingSpinner/InitialLoadingSpinner.styles"

export * from "./components/BusyOverlay/BusyOverlay"
export * from "./components/BusyOverlay/BusyOverlay.styles"

export * from "./components/MessageBox/MessageBox"
export * from "./components/MessageBox/MessageBox.styles"

export * from "./components/AppSwitch/AppSwitch"

export * from "./components/ThemedApplication/ThemedApplication"

export * from "./constants"
export * from "./defaultSettings"
export { IAppSettings } from "./appUtil"

export const translations = {
    de,
    en
}

/**
 * Sets the given component in the ComponentFactory for the given name.
 *
 * @param name Name of the component to override. See {@link ComponentName}.
 * @param component The React component to set for the given name.
 *
 * @example
 * import { registerDefaultApplicationComponents, ComponentName } from "@encoway/cui-application-components";
 * registerDefaultApplicationComponents()
 *     .override(ComponentName.Header, <h1>MyCustomHeader</h1>);
 */
export function override(name: string, component: any) {
    ComponentFactory.register(name, component)
    return { override } // needed to override more than one component
}

/**
 * Sets all default components in the ComponentFactory.
 */
export function registerDefaultApplicationComponents() {
    ComponentFactory.register(ComponentName.Header, Header)
    ComponentFactory.register(ComponentName.HeaderMenu, HeaderMenu)
    ComponentFactory.register(
        ComponentName.InitialLoadingSpinner,
        InitialLoadingSpinner
    )
    ComponentFactory.register(ComponentName.BusyOverlay, BusyOverlay)
    ComponentFactory.register(ComponentName.MessageBox, MessageBox)

    ComponentFactory.register(ComponentName.ProductTitle, ProductTitle)
    ComponentFactory.register(ComponentName.ProductText, ProductText)
    ComponentFactory.register(ComponentName.ProductPrice, ProductPrice)

    ComponentFactory.register(ComponentName.Visualization, Visualization)

    ComponentFactory.register(ComponentName.AssemblyApp, AssemblyApp)
    ComponentFactory.register(ComponentName.CuiApp, CUIApp)

    ComponentFactory.register(ComponentName.ARDialog, ARDialog)

    return { override }
}
